import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class VariantesProveedorView extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        var rawUrl = window.location.toString();
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {};
        }
        this.state.modelValidation = {

        }

        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }
    componentDidMount() {
        this.populateData();
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/variantesProveedor/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }

    render() {
        return (
            <div >
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="etiquetaCore">
                                    <FormattedMessage id='EtiquetaCore' />
                                </Label>
                                <Input
                                    id="etiquetaCore"
                                    name="etiquetaCore"
                                    type="text"
                                    value={this.state.model.etiquetaCore}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="calibre">
                                    <FormattedMessage id='Calibre' />
                                </Label>
                                <Input
                                    id="calibre"
                                    name="calibre"
                                    type="text"
                                    value={this.state.model.calibre}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label for="cajasPorPaleta">
                                    <FormattedMessage id='CajasPorPaleta' />
                                </Label>
                                <Input
                                    id="cajasPorPaleta"
                                    name="cajasPorPaleta"
                                    type="text"
                                    value={this.state.model.cajasPorPaleta}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="pais">
                                    <FormattedMessage id='Pais' />
                                </Label>
                                <Input
                                    id="pais"
                                    name="pais"
                                    type="text"
                                    value={this.state.model.pais}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label for="retailVariantId">
                                    <FormattedMessage id='RetailVariantId' />
                                </Label>
                                <Input
                                    id="retailVariantId"
                                    name="retailVariantId"
                                    type="text"
                                    value={this.state.model.retailVariantId}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        
                    </Row>
                    
                    <FormGroup>
                        <Label for="nombre">
                            <FormattedMessage id='VariantName' />
                        </Label>
                        <Input
                            id="nombre"
                            name="nombre"
                            type="text"
                            value={this.state.model.nombre}
                            disabled
                        />
                        <FormFeedback>
                            {this.state.model.nombre == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                        </FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="descripcion">
                            <FormattedMessage id='VariantDescription' />
                        </Label>
                        <Input
                            id="descripcion"
                            name="descripcion"
                            type="text"
                            value={this.state.model.descripcion}
                            disabled
                        />
                    </FormGroup>
                </Form>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label for="productNetWeight">
                                <FormattedMessage id='ProductNetWeight' />
                            </Label>
                            <Input
                                id="productNetWeight"
                                name="productNetWeight"
                                type="number"
                                onChange={this.handleChange}
                                value={this.state.model.productNetWeight}
                                valid={this.getValidationValue(this.state.modelValidation.productNetWeight)}
                                invalid={!this.getValidationValue(this.state.modelValidation.productNetWeight)}
                            />
                            <FormFeedback>
                                {this.state.model.productNetWeight == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label for="productTaraWeight">
                                <FormattedMessage id='ProductTaraWeight' />
                            </Label>
                            <Input
                                id="productTaraWeight"
                                name="productTaraWeight"
                                type="number"
                                onChange={this.handleChange}
                                value={this.state.model.productTaraWeight}
                                valid={this.getValidationValue(this.state.modelValidation.productTaraWeight)}
                                invalid={!this.getValidationValue(this.state.modelValidation.productTaraWeight)}
                            />
                            <FormFeedback>
                                {this.state.model.productTaraWeight == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
                
                

            </div>
        );
    }
    async populateData() {
        this.setState({ loading: true },
            async () => {
            }
        );

    }

}